import React, { useEffect, useState } from "react";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import CustomDatePicker from "../../../../components/common/CustomDatePicker/CustomDatePicker";
import CustomRadio from "../../../../components/common/CustomRadio/CustomRadio";
import CustomFileUpload from "../../../../components/common/CustomFileUpload/CustomFileUpload";
import CustomTextArea from "../../../../components/common/CustomTextArea/CustomTextArea";
import BodyHeader from "../../../../components/common/CommonBodyHeader";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
   fetchSingleHelperMasterAsync,
   updateHelperMasterAsync,
} from "../../../../redux/features/helperMaster";
import {
   fetchAllContractorsAsync,
   fetchAllFleetAsync,
} from "../../../../redux/features/driverMaster";
import { FormikProvider, useFormik } from "formik";
import toast from "react-hot-toast";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import { HelperMasterValidationSchema } from "../../../../constansts/validationSchema";
import { singleFleetApiCall } from "../../../../Api/api";
import useFocusErrorField from "../../../../Hooks/useFocusErrorField";

export default function HelperMasterEdit() {
   const dispatch = useDispatch();
   const navigate = useNavigate();
   const [vehicleDriverName, setVehicleDriverName] = useState("");

   const driverMaster = useSelector((state) => state.driverMaster);
   const contractorsData = driverMaster?.contractors?.map?.((item) => ({
      label: item?.name,
      value: item?.id,
   }));

   // const vendorsData = driverMaster?.singleVehicleMaster?.map?.((item) => ({
   //    label: item?.vehicle_no,
   //    value: item?.id,
   // }));

   const singleHelperMaster = useSelector(
      (state) => state.helperMaster.singleHelperMaster,
   );
   const params = useParams();

   const formik = useFormik({
      initialValues: {
         name: "",
         mobile: "",
         driving_licence: "",
         dob: "",
         dateOfJoining: "",
         dateOfExit: "",
         aadharNo: "",
         aadharDocument: "",
         panNo: "",
         panDocument: "",
         helperImage: "",
         address: "",

         accountNumber: "",
         bankName: "",
         ifscCode: "",
         accountHolderName: "",
         monthlySalaryAmount: "",
         payRollType: "",

         // for helper
         helperAccountNumber: "",
         helperBankName: "",
         helperIfscCode: "",
         helperAccountHolderName: "",
         helperMonthlyAmount: "",

         contractorName: "",
         monthlySalaryCommissionAmount: "",
      },
      validationSchema: HelperMasterValidationSchema,
      onSubmit: (formData) => {
         dispatch(backdropLoadingAction(true));
         const data = {
            id: singleHelperMaster.id,
            //vehicle_no: formData.vehicle_no,
            driving_licence: formData.driving_licence,
            name: formData.name,
            mobile: formData.mobile,
            dob: formData.dob,
            doj: formData.dateOfJoining,
            doe: formData.dateOfExit || "",
            helper_image: formData.helperImage,
            address: formData.address,
            aadhar_card: formData.aadharNo,
            aadhar_card_doc: formData.aadharDocument,
            pan_card: formData.panNo,
            pan_card_doc: formData.panDocument,
            payroll: formData.payRollType,

            model_id: 5,
            action_id: 2,
            _method: "PATCH",
         };
         if (typeof data.aadhar_card_doc === "string") {
            delete data.aadhar_card_doc;
         }
         if (typeof data.pan_card_doc === "string") {
            delete data.pan_card_doc;
         }
         if (typeof data.helper_image === "string") {
            delete data.helper_image;
         }

         if (data.payroll === "Oillogistics Pay Roll") {
            data.account_number = formData.accountNumber;
            data.bank_name = formData.bankName;
            data.ifsc_code = formData.ifscCode;
            data.account_holder_name = formData.accountHolderName;
            data.monthly_salary_amount = formData.monthlySalaryAmount;
         }

         if (data.payroll === "Contractor") {
            data.contractor_master_id = formData.contractorName;
            data.monthly_salary_commission_amount =
               formData.monthlySalaryCommissionAmount;
            data.helper_account_number = formData.helperAccountNumber;
            data.helper_bank_name = formData.helperBankName;
            data.helper_ifsc_code = formData.helperIfscCode;
            data.helper_account_holder_name = formData.helperAccountHolderName;
            data.helper_monthly_salary_amount = formData.helperMonthlyAmount;
         }
         const newData = new FormData();
         Object.keys(data).forEach((key) => {
            newData.append(key, data[key]);
         });

         dispatch(
            updateHelperMasterAsync({
               data: newData,
               done: () => {
                  resetForm();
                  dispatch(backdropLoadingAction(false));
                  toast.success("Helper master updated successfully.");
                  dispatch(
                     fetchSingleHelperMasterAsync({
                        id: params?.id,
                     }),
                  );
               },
               err: (error) => {
                  dispatch(backdropLoadingAction(false));
                  //toast.error(error);
               },
            }),
         );
      },
   });

   const {
      handleSubmit,
      resetForm,
      getFieldProps,
      setFieldValue,
      setValues,
      isSubmitting,
      values,
      errors,
      touched,
   } = formik;

   // Focus error field
   useFocusErrorField(errors, isSubmitting);

   // Fetch single HelperMaster data
   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      let pending = 2;
      const handleDone = () => {
         pending -= 1;
         if (pending <= 0) {
            dispatch(backdropLoadingAction(false));
         }
      };

      dispatch(
         fetchSingleHelperMasterAsync({
            id: params?.id,
            done: handleDone,
            err: handleDone,
         }),
      );

      dispatch(
         fetchAllFleetAsync({
            done: handleDone,
            err: handleDone,
         }),
      );
   }, [dispatch, params?.id]);

   useEffect(() => {
      if (singleHelperMaster) {
         setValues({
            name: singleHelperMaster?.name,
            mobile: singleHelperMaster?.mobile,
            driving_licence: singleHelperMaster?.driving_licence,
            dob: singleHelperMaster?.dob,
            dateOfJoining: singleHelperMaster?.doj,
            dateOfExit: singleHelperMaster?.doe,
            aadharNo: singleHelperMaster?.aadhar_card,
            aadharDocument: singleHelperMaster?.aadhar_card_doc,
            panNo: singleHelperMaster?.pan_card ? singleHelperMaster.pan_card : "",
            panDocument: singleHelperMaster?.pan_card_doc,
            helperImage: singleHelperMaster?.helper_image,
            address: singleHelperMaster?.address,
            payRollType: singleHelperMaster?.payroll,

            bankName: singleHelperMaster?.bank_name,
            ifscCode: singleHelperMaster?.ifsc_code,
            accountNumber: singleHelperMaster?.account_number,
            accountHolderName: singleHelperMaster?.account_holder_name,
            monthlySalaryAmount: singleHelperMaster?.monthly_salary_amount,

            helperAccountNumber: singleHelperMaster?.helper_account_number,
            helperBankName: singleHelperMaster?.helper_bank_name,
            helperIfscCode: singleHelperMaster?.helper_ifsc_code,
            helperAccountHolderName: singleHelperMaster?.helper_account_holder_name,
            helperMonthlyAmount: singleHelperMaster?.helper_monthly_salary_amount,

            contractorName: singleHelperMaster?.contractor_master_id,
            monthlySalaryCommissionAmount:
               singleHelperMaster?.monthly_salary_commission_amount,

            //vehicle_no: singleHelperMaster?.fleet_master_id,
         });
         if (singleHelperMaster?.fleet_master_id) {
            singleFleetApiCall(singleHelperMaster.fleet_master_id)
               .then(({ data }) => {
                  const driverName = data?.res?.name || "No driver available";
                  setVehicleDriverName(driverName);
               })
               .catch(() => setVehicleDriverName("No driver available"));
         } else {
            setVehicleDriverName("No driver available");
         }
      }
   }, [singleHelperMaster]);

   // Fetch contractor list
   useEffect(() => {
      dispatch(backdropLoadingAction(true));
      dispatch(
         fetchAllContractorsAsync({
            done: () => {
               dispatch(backdropLoadingAction(false));
            },
            err: () => {
               dispatch(backdropLoadingAction(false));
            },
         }),
      );
   }, []);

   const handlePayRollSelect = (event) => {
      setFieldValue("payRollType", event.target.value);
   };

   // useEffect(() => {
   //    if (values?.vehicle_no) {
   //       singleFleetApiCall(values.vehicle_no)
   //          .then(({ data }) => {
   //             const driverName = data?.res?.driver_master?.name || "No driver available";
   //             setVehicleDriverName(driverName);
   //          })
   //          .catch(() => setVehicleDriverName("No driver available"));
   //    } else {
   //       setVehicleDriverName("No driver available");
   //    }
   // }, [values?.vehicle_no]);

   return (
      <div>
         <BodyHeader title="Edit Helper Master" />
         <FormikProvider value={formik}>
            <div className="p-3 shadow-lg">
               <div className="row">
                  <div className="col-lg-12">
                     <div className="card card-primary">
                        <div className="card-header">
                           <h3 className="card-title">Personal Details</h3>
                        </div>
                        <div className="card-body row">
                           {/* <div className="col-lg-3">
                              <CustomDropdown
                                 require
                                 label="Vehicle No."
                                 name="vehicle_no"
                                 id="vehicle_no"
                                 values={vendorsData?.filter(
                                    (item) => item.value === values?.vehicle_no,
                                 )}
                                 optionData={vendorsData}
                                 onChange={(values) => {
                                    setFieldValue("vehicle_no", values?.[0]?.value);
                                 }}
                                 errors={
                                    Boolean(touched.vehicle_no) &&
                                    Boolean(errors.vehicle_no)
                                 }
                                 message={errors.vehicle_no}
                              />
                              <p className="mt-2 mb-0 text-muted small">
                                 Driver Name: {vehicleDriverName || "No driver available"}
                              </p>
                           </div> */}

                           <div className="col-lg-3">
                              <CustomInput
                                 require
                                 label="Name"
                                 id="driverName"
                                 placeholder="Enter Name"
                                 {...getFieldProps("name")}
                                 errors={touched?.name && errors?.name}
                                 message={errors?.name}
                              />
                           </div>
                           <div className="col-lg-3">
                              <CustomInput
                                 require
                                 label="Mobile No"
                                 id="mobile"
                                 placeholder="Enter Mobile No"
                                 {...getFieldProps("mobile")}
                                 errors={
                                    Boolean(touched.mobile) && Boolean(errors.mobile)
                                 }
                                 message={errors.mobile}
                              />
                           </div>

                           <div className="col-lg-3">
                              <CustomInput
                                 label="Driving Licence"
                                 placeholder="Driving Licence"
                                 {...getFieldProps("driving_licence")}
                                 errors={
                                    touched.driving_licence && errors.driving_licence
                                 }
                                 message={errors.driving_licence}
                              />
                           </div>

                           <div className="col-lg-3">
                              <CustomDatePicker
                                 require
                                 label="DOB"
                                 placeholder="Select DOB"
                                 {...getFieldProps("dob")}
                                 errors={touched?.dob && errors?.dob}
                                 message={errors?.dob}
                              />
                           </div>

                           {/* Date of Joining */}
                           <div className="col-lg-3">
                              <CustomDatePicker
                                 require
                                 label="Date of Joining"
                                 placeholder="Select Date of Joining"
                                 {...getFieldProps("dateOfJoining")}
                                 errors={touched?.dateOfJoining && errors?.dateOfJoining}
                                 message={errors?.dateOfJoining}
                              />
                           </div>
                           {/* Date of Exit */}
                           <div className="col-lg-3">
                              <CustomDatePicker
                                 label="Date of Exit"
                                 placeholder="Select Date of Exit"
                                 {...getFieldProps("dateOfExit")}
                                 errors={touched?.dateOfExit && errors?.dateOfExit}
                                 message={errors?.dateOfExit}
                              />
                           </div>

                           <div className="col-lg-3">
                              <CustomInput
                                 require
                                 label="Aadhar Card"
                                 id="aadharCard"
                                 placeholder="Enter Aadhar Card"
                                 {...getFieldProps("aadharNo")}
                                 errors={touched?.aadharNo && errors?.aadharNo}
                                 message={errors?.aadharNo}
                              />
                           </div>
                           <div className="col-lg-3">
                              <CustomFileUpload
                                 label="Aadhar Document"
                                 name="aadharDocument"
                                 require={true}
                                 accept=".pdf,.jpg,.png,.jpeg"
                                 {...getFieldProps("aadharDocument")}
                                 onChange={(e) =>
                                    setFieldValue("aadharDocument", e.target.files[0])
                                 }
                                 errors={
                                    touched?.aadharDocument && errors?.aadharDocument
                                 }
                                 message={errors?.aadharDocument}
                              />
                           </div>
                           <div className="col-lg-3">
                              <CustomInput
                                 label="Pan Card"
                                 id="panCard"
                                 placeholder="Enter Pan Card"
                                 {...getFieldProps("panNo")}
                                 errors={touched?.panNo && errors?.panNo}
                                 message={errors?.panNo}
                              />
                           </div>
                           <div className="col-lg-3">
                              <CustomFileUpload
                                 label="Pan Card Document"
                                 {...getFieldProps("panDocument")}
                                 accept=".pdf,.jpg,.png,.jpeg"
                                 onChange={(e) =>
                                    setFieldValue("panDocument", e.target.files[0])
                                 }
                                 errors={touched?.panDocument && errors?.panDocument}
                                 message={errors?.panDocument}
                              />
                           </div>
                           <div className="col-lg-3">
                              <CustomFileUpload
                                 label="helper Image"
                                 id="helperImage"
                                 name="helperImage"
                                 accept=".jpg,.png,.jpeg"
                                 require={true}
                                 {...getFieldProps("helperImage")}
                                 onChange={(e) =>
                                    setFieldValue("helperImage", e.target.files[0])
                                 }
                                 errors={touched?.helperImage && errors?.helperImage}
                                 message={errors?.helperImage}
                              />
                           </div>
                           <div className="col-lg-12">
                              <CustomTextArea
                                 label="Address"
                                 placeholder="Enter Address"
                                 {...getFieldProps("address")}
                                 errors={touched?.address && errors?.address}
                                 message={errors?.address}
                              />
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               {/* Tyre Sec */}
               <div className="row">
                  <div className="col-lg-12">
                     <div className="card card-primary">
                        <div className="card-header">
                           <h3 className="card-title">Pay roll</h3>
                        </div>

                        <div className="card-body">
                           <div className="form-group">
                              <CustomRadio
                                 label="Oil Logistics Pay Roll"
                                 id="eisakuPayRoll"
                                 value="Oillogistics Pay Roll"
                                 checked={
                                    formik.values?.payRollType === "Oillogistics Pay Roll"
                                 }
                                 onChange={handlePayRollSelect}
                              />
                              <CustomRadio
                                 label="Contractor"
                                 value="Contractor"
                                 id="contractor"
                                 checked={formik.values?.payRollType === "Contractor"}
                                 onChange={(event) =>
                                    setFieldValue("payRollType", event.target.value)
                                 }
                              />
                              <CustomRadio
                                 label="Self"
                                 value="Self"
                                 id="self"
                                 checked={formik.values?.payRollType === "Self"}
                                 onChange={(event) =>
                                    setFieldValue("payRollType", event.target.value)
                                 }
                              />
                           </div>
                           {formik.values?.payRollType === "Contractor" && (
                              <div className="row">
                                 <div className="col-lg-6">
                                    <CustomDropdown
                                       require
                                       label="Contractor Name"
                                       placeholder="Enter contractor Name"
                                       optionData={contractorsData}
                                       values={contractorsData?.filter(
                                          (item) => item.value === values.contractorName,
                                       )}
                                       onChange={(values) => {
                                          setFieldValue(
                                             "contractorName",
                                             values[0]?.value,
                                          );
                                       }}
                                       errors={
                                          touched?.contractorName &&
                                          errors?.contractorName
                                       }
                                       message={errors?.contractorName}
                                    />
                                 </div>
                                 <div className="col-lg-6">
                                    <CustomInput
                                       require
                                       label="Monthly Commission Amount"
                                       id="monthlyCommAmount"
                                       placeholder="Enter monthly commission amount"
                                       {...getFieldProps("monthlySalaryCommissionAmount")}
                                       errors={
                                          touched?.monthlySalaryCommissionAmount &&
                                          errors?.monthlySalaryCommissionAmount
                                       }
                                       message={errors?.monthlySalaryCommissionAmount}
                                    />
                                 </div>
                                 <div className="col-lg-4">
                                    <CustomInput
                                       inputType="number"
                                       require={
                                          values?.payRollType === "Oillogistics Pay Roll"
                                       }
                                       label="Account Number"
                                       id="helperAccountNumber"
                                       placeholder="Enter Account Number"
                                       {...getFieldProps("helperAccountNumber")}
                                       errors={
                                          touched?.helperAccountNumber &&
                                          errors?.helperAccountNumber
                                       }
                                       message={errors?.helperAccountNumber}
                                    />
                                 </div>
                                 <div className="col-lg-4">
                                    <CustomInput
                                       require={
                                          values?.payRollType === "Oillogistics Pay Roll"
                                       }
                                       label="Bank name"
                                       id="helperBankName"
                                       placeholder="Enter Bank Name"
                                       {...getFieldProps("helperBankName")}
                                       errors={
                                          touched?.helperBankName &&
                                          errors?.helperBankName
                                       }
                                       message={errors?.helperBankName}
                                    />
                                 </div>
                                 <div className="col-lg-4">
                                    <CustomInput
                                       require={
                                          values?.payRollType === "Oillogistics Pay Roll"
                                       }
                                       label="IFSC Code"
                                       id="helperIfscCode"
                                       placeholder="Enter IFSC Code"
                                       {...getFieldProps("helperIfscCode")}
                                       errors={
                                          touched?.helperIfscCode &&
                                          errors?.helperIfscCode
                                       }
                                       message={errors?.helperIfscCode}
                                    />
                                 </div>

                                 <div className="col-lg-4">
                                    <CustomInput
                                       require={
                                          values?.payRollType === "Oillogistics Pay Roll"
                                       }
                                       label="Account Holder Name"
                                       id="helperAccountHolderName"
                                       placeholder="Enter Account Holder name"
                                       {...getFieldProps("helperAccountHolderName")}
                                       errors={
                                          touched?.helperAccountHolderName &&
                                          errors?.helperAccountHolderName
                                       }
                                       message={errors?.helperAccountHolderName}
                                    />
                                 </div>
                                 <div className="col-lg-4">
                                    <CustomInput
                                       inputType="number"
                                       require={
                                          values?.payRollType === "Oillogistics Pay Roll"
                                       }
                                       label="Monthly salary amount"
                                       id="helperMonthlyAmount"
                                       placeholder="Enter Monthly salary amount"
                                       {...getFieldProps("helperMonthlyAmount")}
                                       errors={
                                          touched?.helperMonthlyAmount &&
                                          errors?.helperMonthlyAmount
                                       }
                                       message={errors?.helperMonthlyAmount}
                                    />
                                 </div>
                              </div>
                           )}

                           {values?.payRollType === "Oillogistics Pay Roll" && (
                              <div className="row">
                                 <div className="col-lg-4">
                                    <CustomInput
                                       inputType="number"
                                       require={
                                          values?.payRollType === "Oillogistics Pay Roll"
                                       }
                                       label="Account Number"
                                       id="AccountNumber"
                                       placeholder="Enter Account Number"
                                       {...getFieldProps("accountNumber")}
                                       errors={
                                          touched?.accountNumber && errors?.accountNumber
                                       }
                                       message={errors?.accountNumber}
                                    />
                                 </div>
                                 <div className="col-lg-4">
                                    <CustomInput
                                       require={
                                          values?.payRollType === "Oillogistics Pay Roll"
                                       }
                                       label="Bank name"
                                       id="bankName"
                                       placeholder="Enter Bank Name"
                                       {...getFieldProps("bankName")}
                                       errors={touched?.bankName && errors?.bankName}
                                       message={errors?.bankName}
                                    />
                                 </div>
                                 <div className="col-lg-4">
                                    <CustomInput
                                       require={
                                          values?.payRollType === "Oillogistics Pay Roll"
                                       }
                                       label="IFSC Code"
                                       id="ifscCode"
                                       placeholder="Enter IFSC Code"
                                       {...getFieldProps("ifscCode")}
                                       errors={touched?.ifscCode && errors?.ifscCode}
                                       message={errors?.ifscCode}
                                    />
                                 </div>

                                 <div className="col-lg-4">
                                    <CustomInput
                                       require={
                                          values?.payRollType === "Oillogistics Pay Roll"
                                       }
                                       label="Account Holder Name"
                                       id="accountHolderName"
                                       placeholder="Enter Account Holder name"
                                       {...getFieldProps("accountHolderName")}
                                       errors={
                                          touched?.accountHolderName &&
                                          errors?.accountHolderName
                                       }
                                       message={errors?.accountHolderName}
                                    />
                                 </div>
                                 <div className="col-lg-4">
                                    <CustomInput
                                       inputType="number"
                                       require={
                                          values?.payRollType === "Oillogistics Pay Roll"
                                       }
                                       label="Monthly salary amount"
                                       id="monthlyAmount"
                                       placeholder="Enter Monthly salary amount"
                                       {...getFieldProps("monthlySalaryAmount")}
                                       errors={
                                          touched?.monthlySalaryAmount &&
                                          errors?.monthlySalaryAmount
                                       }
                                       message={errors?.monthlySalaryAmount}
                                    />
                                 </div>
                              </div>
                           )}

                           {values.payRollType === "Self" && (
                              <div className="row mt-2">
                                 <div className="col-12 col-md-6 col-lg-4">
                                    <div className="p-3 border rounded bg-light d-flex align-items-center shadow-sm">
                                       <div className="flex-grow-1">
                                          <label className="form-label text-muted small text-uppercase fw-bold mb-1">
                                             Payment Mode
                                          </label>
                                          <div className="d-flex align-items-center ml-3">
                                             <input
                                                type="checkbox"
                                                className="form-check-input me-2"
                                                checked
                                                readOnly
                                                style={{
                                                   width: "1.2rem",
                                                   height: "1.2rem",
                                                   accentColor: "#0d6efd",
                                                   opacity: 1,
                                                }}
                                             />
                                             <span className="fw-bold text-dark fs-5 ml-1 mt-1">
                                                Cash
                                             </span>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           )}
                        </div>
                     </div>
                  </div>
                  <div className="col-12 mt-3 text-center">
                     <button
                        className="btn btn-primary px-4 py-3"
                        type="submit"
                        onClick={handleSubmit}
                     >
                        <h6 className="mb-0 text-uppercase">Submit</h6>
                     </button>
                     {/* <button className="btn btn-danger ml-3 px-4 py-3" type="submit">
                     <h6 className="mb-0 text-uppercase">reset</h6>
                  </button> */}
                  </div>
               </div>
            </div>
         </FormikProvider>
      </div>
   );
}
